export const DATE_FORMAT = 'MMMM dd, y - HH:mm aaa';
